var userAgent = window.navigator.userAgent.toLowerCase();
$(document).ready(function() {
  imagesLoadListener(document.body, function() {

    $("body").addClass("afterload");
    var start_pos = 0;
    $(document).scroll(function(){
      var now = $(this).scrollTop();

      $(".section").each(function(){
        if(now+($(window).height()/4) > $(this).offset().top && now +($(window).height()/4) < $(this).offset().top + $(this).innerHeight() ){
          $(this).addClass("on");
          $(".pagination p").eq($(this).index()).addClass("on");
        }else {
          $(this).removeClass("on");
          $(".pagination p").eq($(this).index()).removeClass("on");
        }
      });

      $(".scrollAnimate").each(function(){
        if( now+($(window).height()-200) > $(this).offset().top ){
          $(this).addClass("on");
        }
      });
      $(".scrollAnimate__parent").each(function(){
        if( now+($(window).height()-200) > $(this).offset().top ){
          $(this).addClass("on");
        }
      });

    });

    $("html,body").trigger("scroll");

  });

});



var imagesLoadListener = (function() {

    var imageCollector = function(expectedCount, completeFn) {
        var receivedCount = 0;
        return function() {
            receivedCount++;
            if(receivedCount === expectedCount) {
                completeFn();
            }
        };
    };

    var imagesLoadListener = function(element, callback) {
        var images = element.querySelectorAll('img');
        if(images === null) {
            callback();
            return;
        }

        //画像の数だけloadListenerが呼ばれたらcallbackが呼ばれる;
        var loadListener = imageCollector(images.length, callback);
        Array.prototype.forEach.call(images, function(img) {
            if(img.complete) {
                loadListener();
            }else {
                img.onload = loadListener;
            }
        });
    };

    return imagesLoadListener;
})();
